<template>
  <b-card>
    <b-form class="form" @submit.stop.prevent="onSubmit">
      <div
        role="alert"
        v-bind:class="{ show: errors.length }"
        class="alert fade alert-danger"
      >
        <div class="alert-text" v-for="(error, i) in errors" :key="i">
          {{ error }}
        </div>
      </div>
      <h4>اطلاعات پایه</h4>
      <b-row>
        <b-col>
                <b-form-group
                  id="example-input-group-1"
                  label="تاریخ ثبت نام:"
                  label-for="example-input-1"
                >
                  <b-form-input
                    id="input-4"
                    :disabled="true"
                    v-model="form.created_at"
                  ></b-form-input>
                </b-form-group>
              </b-col>
        <b-col >
          <b-form-group
            id="example-input-group-1"
            label="نوع:"
            label-for="example-input-1"
          >
            <MDDropdown
              :disabled="true"
              v-bind:group="17"
              v-model="$v.form.mdid17_merchant_type.$model"
            ></MDDropdown>
            <b-form-invalid-feedback id="input-1-live-feedback"
              >وارد کردن نام اجباری است</b-form-invalid-feedback
            >
          </b-form-group>
        </b-col>
      </b-row>
      <div v-if="form.mdid17_merchant_type == 1550">
        <PersonInfo v-model="form" v-bind:disabled="true"></PersonInfo>
      </div>
      <div v-if="form.mdid17_merchant_type == 1551">
        <CompanyInfo v-model="form" v-bind:disabled="true"></CompanyInfo>
      </div>
      <h4>اطلاعات تماس</h4>
      <UserAddress v-model="form" v-bind:disabled="true"></UserAddress>
      <!--begin::Action-->
      <div
        class="form-group d-flex flex-wrap justify-content-between align-items-center"
      >
        <!-- <button
          ref="kt_login_signin_submit"
          class="btn btn-primary font-weight-bold px-9 py-4 my-3 font-size-3"
        >ذخیره</button> -->
      </div>
      <!--end::Action-->
    </b-form>
  </b-card>
</template>

<style lang="scss" scoped>
.spinner.spinner-right {
  padding-right: 3.5rem !important;
}
</style>

<script>
import { mapState } from "vuex";
import { LOGIN, LOGOUT } from "@/core/services/store/auth.module";
import PersonInfo from "./PersonInfo";
import CompanyInfo from "./CompanyInfo";
import UserAddress from "./UserAddress";
import { validationMixin } from "vuelidate";
import { email, minLength, required } from "vuelidate/lib/validators";
import httpHelper from "../../helpers/httpHelper";
import sessionHelper from "../../helpers/sessionHelper";
import MDDropdown from "../../components/MDDropdown";
import persianDate from "../../helpers/persianDate";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
export default {
  mixins: [validationMixin],
  name: "login",
  data() {
    return {
      // Remove this dummy login info
      form: {
        name: "",
        email: "",
        fa_name: "",
        fa_family: "",
        fa_father: "",
        en_name: "",
        en_family: "",
        en_father: "",
        mobile: "",
        name: "",
        phone: "",
        pre_phoone: "",
        postalCode: "",
        national_card_number: "",
        merchant_type: 0,
        created_at: '-',
      },
      errors: [],
      merchant_typeList: [
        { value: 0, text: "حقیقی" },
        { value: 1, text: "حقوقی" },
      ],
    };
  },
  validations: {
    form: {
      email: {
        required,
        email,
      },
      fa_name: {
        required,
      },
      fa_family: {
        required,
      },
      national_card_number: {
        required,
      },
      mobile: {
        required,
      },
      mdid17_merchant_type: {
        required,
      },
      fa_father: {},
      //   password: {
      //     required,
      //     minLength: minLength(3)
      //   }
    },
  },
  created() {
  
  },
  components: {
    PersonInfo,
    CompanyInfo,
    UserAddress,
    MDDropdown,
    persianDate
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    resetForm() {
      this.form = {
        email: null,
        password: null,
      };

      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    onSubmit() {
      httpHelper.postData("users", this.form).then((res) => {
        this.$makeToast('success','تایید اطلاعات',"اطلاعات شما با موفقیت تغییر یافت.",5000);  
      });
    },
  },
  computed: {},
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "اطلاعات کاربری" }]);
      httpHelper.getData("users/verify").then((res) => {
      this.form = {
        name: res.name,
        email: res.email,
        fa_name: res.fa_name,
        fa_family: res.fa_family,
        fa_father: res.fa_father,
        en_name: res.en_name,
        en_family: res.en_family,
        en_father: res.en_father,
        mobile: res.mobile,
        name: res.name,
        phone: res.phone,
        pre_phone: res.pre_phone,
        postalCode: res.postalCode,
        national_card_number: res.national_card_number,
        mdid17_merchant_type: res.mdid17_merchant_type,
        mdid18_gender: res.mdid18_gender,
        mdid4_province: res.mdid4_province,
        mdid5_city: res.mdid5_city,
        address: res.address,
        postalCode: res.postalCode,
        com_shenase: res.com_shenase,
        birth_date: res.birth_date,
      };
       if (res.created_at != null) {
        this.form.created_at = persianDate.getDateByFormat(res.created_at);
      } else {
        this.form.created_at = "-";
      }
    });
  },
};
</script>
